module.exports = __webpack_public_path__ + "static/media/girl_cutting_paper.5fad32fa.png";